export const OIDC_API_AUTHORIZATION = "/v2/connect/authorization";
export const OIDC_API_LOGOUT = "/v2/connect/logout";
